import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { TruthSection } from './components/TruthSection';
import { PainSection } from './components/PainSection';
import { DreamOutcome } from './components/DreamOutcome';
import { WhyMethodsFail } from './components/WhyMethodsFail';
import { SystemIntro } from './components/SystemIntro';
import { ModulesBreakdown } from './components/ModulesBreakdown';
import { BenefitsSection } from './components/BenefitsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy-950 font-sans text-slate-300 selection:bg-gold-500/30 selection:text-gold-200" data-id="element-0" data-mp="28ufmg62gz4gf">
      <HeroSection data-id="element-1" data-mp="23w4fc33k781w" />
      <OpeningHook data-id="element-2" data-mp="23ujjma5idj2g" />
      <TruthSection data-id="element-3" data-mp="23v2sl1d6kx4c" />
      <PainSection data-id="element-4" data-mp="23ti5txx3yih1" />
      <DreamOutcome data-id="element-5" data-mp="3ikh8gaq64uzi" />
      <WhyMethodsFail data-id="element-6" data-mp="3iiweonbohg2p" />
      <SystemIntro data-id="element-7" data-mp="3ijfthv617oci" />
      <ModulesBreakdown data-id="element-8" data-mp="3ii4t85bsoyq5" />
      <BenefitsSection data-id="element-9" data-mp="3mlaxj7fckftz" />
      <GuaranteeSection data-id="element-10" data-mp="3mkhm3t5g125i" />
      <UrgencySection data-id="element-11" data-mp="3mjq1fdddwou0" />
      <FinalCTA data-id="element-12" data-mp="3mj6k9yvk64h1" />
      <Footer data-id="element-13" data-mp="3rcj7q5oi4587" />
    </div>;
}